import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './components/main/main.component';
import { SellerMainComponent } from './components/seller-main/seller-main.component';
import { ImpressumComponent } from './components/impressum/impressum.component';

const routes: Routes = [
  {path: '', component: MainComponent},
  {path: 'seller', component: SellerMainComponent},
  {path: 'impressum', component: ImpressumComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
